import { render, staticRenderFns } from "./Users-Detail.vue?vue&type=template&id=0bb2816e"
import script from "./Users-Detail.vue?vue&type=script&lang=js"
export * from "./Users-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports